import { Warning } from "@mui/icons-material";
import { Alert, Box, Typography } from "@mui/joy";
import { ApiChallenge } from "griptonite-api-client";
import { useMemo } from "react";

import getPublishWarnings, { useHideWarningsMap } from "./getPublishWarnings";

const PublishWarningsAlert = ({ tab, challenge }: { tab: string; challenge?: ApiChallenge }) => {
  const publishWarnings = useMemo(() => getPublishWarnings(challenge), [challenge]);

  const hideWarningsMap = useHideWarningsMap(challenge?.uuid);

  return !hideWarningsMap[tab as keyof typeof hideWarningsMap] && publishWarnings.byTab[tab] ? (
    <Alert color="warning" sx={{ marginBottom: 1 }}>
      <Warning />
      <Box>
        <Typography level="title-sm">
          To publish your event, please fix the following issue
          {publishWarnings.byTab[tab].length > 1 ? "s" : ""}:
        </Typography>
        <ul style={{ margin: 0, fontWeight: "bold", paddingLeft: "1.5rem" }}>
          {publishWarnings.byTab[tab].map((warning, i) => (
            <li key={i}>{warning.message}</li>
          ))}
        </ul>
      </Box>
    </Alert>
  ) : null;
};

export default PublishWarningsAlert;
